export function openCloseMenu() {
    const toggleMenu = document.querySelectorAll('[data-js="toggle-menu"]');
    const menuContainer = document.querySelector('[data-js="menu-slider"]');
    // let menuExpanded = toggleMenu[0].getAttribute('aria-expanded');
    const mainMenu = document.querySelector('#main-menu');
    const parentButtons = mainMenu.querySelectorAll('[aria-controls].peer');

    let scrollFromTop = 0;

  // Define `noScroll` outside to ensure it’s the same reference
  function noScroll() {
    window.scrollTo(0, scrollFromTop);
  }

    function checkWindowWidth(){
        if (window.innerWidth <= 1023) {
            menuContainer.setAttribute('aria-hidden', true);
            // menuContainer.setAttribute('inert', true);
            menuContainer.inert = true
            toggleMenu.forEach(elem => elem.setAttribute('aria-hidden', false));
        } else {
            menuContainer.setAttribute('aria-hidden', false);
            menuContainer.inert = false
            toggleMenu.forEach(elem => elem.setAttribute('aria-hidden', true));
        }
        if(isTouchDevice()){
            parentButtons.forEach(btn => {
                btn.setAttribute('aria-expanded', 'false')
                btn.addEventListener('click', handleClick)
                // btn.parentNode.removeEventListener('mouseenter', handleHoverEnter)
                // btn.parentNode.removeEventListener('mouseleave', handleHoverLeave)
            });
        } else {
            parentButtons.forEach(elem => {
                const computedStyle = window.getComputedStyle(elem);
                if (computedStyle.pointerEvents === 'none') {
                    elem.setAttribute('tabindex', "-1")
                    elem.setAttribute('aria-expanded', 'true')
                } else {
                    elem.addEventListener('click', handleClick)
                    elem.parentNode.addEventListener('mouseenter', handleHoverEnter)
                    elem.parentNode.addEventListener('mouseleave', handleHoverLeave)
                    elem.setAttribute('tabindex', "0")
                    elem.setAttribute('aria-expanded', 'false')
                }
            })
        }
    }
    checkWindowWidth()
    function handleResize() {
        checkWindowWidth()
    }

   

    toggleMenu && toggleMenu.forEach(elem => {
        elem.addEventListener('click', function () {
            scrollFromTop = window.scrollY; // Save the scroll position
            let menuExpanded = this.getAttribute('aria-expanded');
            if (menuExpanded !== "true") {
                // Change button's aria-expaded attribute 
                elem.setAttribute('aria-expanded', true);
                menuContainer.setAttribute('aria-hidden', false);
                menuContainer.inert = false;
                // bodyLenis.stop();
                window.addEventListener("scroll", noScroll);
                parentButtons.forEach(btn => btn.addEventListener('click', handleClick));
            } else {
                elem.setAttribute('aria-expanded', false);
                menuContainer.setAttribute('aria-hidden', true);
                // bodyLenis.start();
                window.removeEventListener("scroll", noScroll);
                parentButtons.forEach(btn => btn.removeEventListener('click', handleClick));
                menuContainer.inert = true;
            }
        });
    });

    
    window.addEventListener('resize', debounce(handleResize, 100));
}

// The function changes the aria-expanded attribute from false to true on button click
function handleClick(event) {
    const button = event.target;
    const nextSibling = button.nextElementSibling;
    let expanded = button.getAttribute('aria-expanded');
    console.log('click expanded', expanded, button)
        if (expanded == "true") {
            button.setAttribute('aria-expanded', false)
            // If a parent is clicked we close all the children if any that are open
            button.parentNode.querySelectorAll('[aria-controls].peer').forEach((btn) => btn.setAttribute('aria-expanded', false))
            nextSibling.inert = true                                                       
        } else {
            button.closest('ul').querySelectorAll('[aria-controls].peer').forEach((btn) => btn.setAttribute('aria-expanded', false))
            button.setAttribute('aria-expanded', true)
            nextSibling.inert = false
        }

};

function handleFocus(elem) {
    // parentButtons.forEach(elem => elem.setAttribute('aria-expanded', false))
    // console.log('expanded', expanded, button)
    elem.addEventListener('keyup', (event) => {
        const nextSibling = elem.nextElementSibling;
        let expanded = elem.getAttribute('aria-expanded');
        if (event.key === "Enter") {
            if (expanded == "true") {
                elem.setAttribute('aria-expanded', false)
                nextSibling.inert = true  
            } else {
                console.log('running keyup')
                elem.setAttribute('aria-expanded', true)
                nextSibling.inert = false  
            }
        }
    })
};

// The function changes the aria-expanded attribute from false to true on button's parent li mouseenter and mouseleave NOT on button hover.
function handleHoverEnter(event) {
    const button = event.target.querySelector('[aria-controls]');
    const nextSibling = button.nextElementSibling;
    let expanded = button.getAttribute('aria-expanded');
    if (expanded == "true") {
        null
    } else {
        console.log('running hover enter')
        button.setAttribute('aria-expanded', true)
        nextSibling.inert = false
    }
};
function handleHoverLeave(event) {
    const button = event.target.querySelector('[aria-controls]');
    const nextSibling = button.nextElementSibling;
    let expanded = button.getAttribute('aria-expanded');
    if (expanded == "true") {
        button.setAttribute('aria-expanded', false)
        nextSibling.inert = true
    } else {
        null
    }
};



function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}

function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}